import React from 'react';
import Box from '@sendsprint/ui-react/dist/components/Box';
import Text from '@sendsprint/ui-react/dist/components/Text';
import Image from '@src/components/image';
import cs from 'classnames';

interface Props {
  icon: string;
  handleSelectItem: () => void;
  header: string;
  description: string;
  isSelected: boolean;
}

const PaymentTypeItem = ({ icon, handleSelectItem, description, header, isSelected }: Props) => {
  return (
    <button
      type="button"
      className={cs(
        'ss-flex ss-flex-col focus:ss-focus-ring ss-border ss-text-left md:ss-flex-row ss-justify-between ss-px-6 ss-py-6 ss-bg-white ss-rounded-[20px] ss-cursor-pointer',
        {
          'ss-border-[#16342E]': isSelected,
          'ss-border-transparent': !isSelected
        }
      )}
      onClick={handleSelectItem}>
      <Image variant="eager-load" alt="Single Payment" src={icon} className="ss-w-[73px] ss-mr-3" />
      <Box>
        <Text className="ss-payment-link-title ss-mb-1">{header}</Text>
        <Text className="ss-payment-link-sub-text">{description}</Text>
      </Box>
    </button>
  );
};

export default PaymentTypeItem;
